import { render, staticRenderFns } from "./MobileTooltip.vue?vue&type=template&id=b22528d6&scoped=true"
import script from "./MobileTooltip.vue?vue&type=script&lang=js"
export * from "./MobileTooltip.vue?vue&type=script&lang=js"
import style0 from "./MobileTooltip.vue?vue&type=style&index=0&id=b22528d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22528d6",
  null
  
)

export default component.exports